/* eslint-disable */
import { regionSettingsMessages } from '@ringcentral-integration/commons/modules/RegionSettings/regionSettingsMessages';
export default {
  region: '地區',
  [regionSettingsMessages.saveSuccess]: '設定已成功儲存。',
  [regionSettingsMessages.dialingPlansChanged]:
    '您的帳戶不再支援先前的地區。\n    請確認您的新{regionSettingsLink}。',
  regionSettings: '地區設定',
  [regionSettingsMessages.areaCodeInvalid]: '請輸入有效的區碼。',
} as const;

// @key: @#@"region"@#@ @source: @#@"Region"@#@
// @key: @#@"[regionSettingsMessages.saveSuccess]"@#@ @source: @#@"Settings saved successfully."@#@
// @key: @#@"[regionSettingsMessages.dialingPlansChanged]"@#@ @source: @#@"The previous region is no longer supported for your account.\n    Please verify your new {regionSettingsLink}."@#@
// @key: @#@"regionSettings"@#@ @source: @#@"region settings"@#@
// @key: @#@"[regionSettingsMessages.areaCodeInvalid]"@#@ @source: @#@"Please enter a valid area code."@#@
